import React, { FC } from 'react';
import { NotificationBanner } from 'src/components/widgets/notificationBanner';
import { T } from 'src/shared/helpers';

interface DiscoveryFillBackgroundImportBannerProps {
    /** Fires the default-background-gallery import; the parent shows the shared import progress overlay and
     * reboots the customizer iframe once it completes. */
    onImport: () => void;
}

/**
 * Discovery-mode "no background gallery yet" banner, shown under the Tools pills when the merchant engages the
 * Fill Background tool but is a legacy account with no background gallery at all (never got the default import
 * and has no images of their own) — so the customizer's gallery tab would render empty. Its button launches the
 * default-gallery import directly (no gallery-manager detour): the parent runs the same `importDefaultLibrary`
 * mutation the setup page uses and renders the shared `GalleryImportBlockingOverlay` for progress, then reboots
 * the iframe so the real gallery loads. Sellers who already have a default or personalized gallery never see this.
 */
const DiscoveryFillBackgroundImportBanner: FC<DiscoveryFillBackgroundImportBannerProps> = ({ onImport }) => (
    <NotificationBanner
        type='INFO'
        variant='extended'
        content={
            <>
                <strong>{T._('Add a background gallery', 'Admin')}</strong>
                {'\n'}
                {T._(
                    "This account doesn't have a background gallery yet. Import Zakeke's ready-made set so customers can fill an area with those backgrounds. You can edit, sort or add your own anytime from Customization Experience → Fill Background.",
                    'Admin'
                )}
            </>
        }
        buttons={[
            {
                label: T._('Import background gallery', 'Admin'),
                onClick: onImport
            }
        ]}
    />
);

export default DiscoveryFillBackgroundImportBanner;
